import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UserRole } from '../models/user-role';
import { JsonHttpService } from '../../shared/http/json-http.service';

@Injectable({
    providedIn: 'root'
})
export class UserRoleService {

    constructor(private httpService: JsonHttpService) { }

    getUserRole(roleId: number): Promise<UserRole> {
        const options = {
            params: new HttpParams()
                .set('roleId', `${roleId}`)
        };
        return this.httpService.get('/api/users/roles/get-role', options).toPromise();
    }

    getUserRoles(): Promise<UserRole[]> {
        return this.httpService.get('/api/users/roles/get-roles').toPromise();
    }

    saveUserRole(userRole: UserRole): Promise<UserRole> {
        return this.httpService.post('/api/users/roles/save-role', userRole).toPromise();
    }

    deleteUserRole(userRoleId: number): Promise<void> {
        const options = { params: new HttpParams().set('roleId', `${userRoleId}`) };
        return this.httpService.post('/api/users/roles/delete-role', null, options).toPromise();
    }
}
